import { send, INTERACTION_TYPES } from '../javascripts/apopheniaLogger';

export default () => {
  const shareLink = document.querySelector('#profile-share-link');

  if (!shareLink || !window.navigator.clipboard) return;

  const originalText = shareLink.textContent;
  const urlObj = new URL(window.location.href);
  urlObj.searchParams.set('shared', '1');
  const url = urlObj.toString();
  const rfid = window.localStorage.getItem('trusted:real_estate:rfid');

  if (rfid) {
    document.getElementById(
      'results_nav:agents_link'
    ).href = `/trusted/referrals/residential-real-estate/${rfid}`;
    document.querySelector('.elp-ResultsNav').style.display = 'block';
  }

  async function copyPageUrl() {
    try {
      await window.navigator.clipboard.writeText(url);
      shareLink.textContent = 'Copied!';

      send({
        account_key: shareLink.dataset.accountKey,
        screen_id: shareLink.dataset.screenId,
        element_id: shareLink.id,
        page_url: window.location.href,
        referral_key: window.localStorage.getItem('trusted:real_estate:rfid'),
        interaction_type: INTERACTION_TYPES.CLICKED
      });

      setTimeout(() => {
        shareLink.textContent = originalText;
        shareLink.blur();
      }, 3000);
    } catch (err) {
      return;
    }
  }

  shareLink.addEventListener('click', function (e) {
    e.preventDefault();

    copyPageUrl();
  });
};
